import { BaseRole } from "./base";

export class PIO extends BaseRole {
    getView(storage, gameInProgress) {
        return storage.getViewPio(gameInProgress);
    }

    static newFromData(data) {
        let instance = new PIO();
        instance.import(data);
        return instance;
    }
}